module.exports = __webpack_public_path__ + "img/TrolleyCS4.a242758a.jpg";